module.exports = __webpack_public_path__ + "img/002-energy.251ee87f.svg";